import React from 'react';
import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const MainTitle = ({ children, subtitle, actions }) => (
    <Box
        display="flex"
        justifyContent="space-between"
        alignItems={subtitle ? 'flex-start' : 'center'}
        mb={2}
    >
        <Box>
            <Typography variant="h5" component="h2" sx={{ fontWeight: 'bold' }}>
                {children}
            </Typography>
            {subtitle ?
                <Typography
                    component="div"
                    variant="body2"
                    color="text.secondary"
                    sx={{
                        mt: 0.25,
                        fontSize: 13,
                        '& strong': {
                            fontWeight: 700,
                        },
                        '& code': {
                            fontFamily: 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace',
                            fontSize: '0.92em',
                        },
                        '& a': {
                            display: 'inline-flex',
                            alignItems: 'center',
                            ml: 0.5,
                            verticalAlign: 'middle',
                        },
                    }}
                >
                    {subtitle}
                </Typography> :
                null}
        </Box>
        {actions}
    </Box>
);

MainTitle.propTypes = {
    children: PropTypes.node.isRequired,
    subtitle: PropTypes.node,
    actions: PropTypes.node,
};

export default MainTitle;
